"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Icon_1 = require("../../Icon");
var utils_1 = require("../../../utils");
var variables_1 = require("../../../config/variables");
var A_SIZES = {
    normal: variables_1.FONT_SIZE.NORMAL,
    small: variables_1.FONT_SIZE.SMALL,
    tiny: variables_1.FONT_SIZE.TINY,
};
var A = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    text-decoration: none;\n    cursor: pointer;\n    color: ", ";\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n\n    &:hover {\n        text-decoration: underline;\n    }\n\n    ", "\n\n    ", "\n"], ["\n    font-size: ", ";\n    text-decoration: none;\n    cursor: pointer;\n    color: ", ";\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n\n    &:hover {\n        text-decoration: underline;\n    }\n\n    ",
    "\n\n    ",
    "\n"])), function (props) { return (props.size ? A_SIZES[props.size] : 'inherit'); }, function (props) { return props.theme.TYPE_DARK_GREY; }, function (props) {
    return props.variant === 'underline' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            text-decoration: underline;\n        "], ["\n            text-decoration: underline;\n        "])));
}, function (props) {
    return props.variant === 'nostyle' && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            color: inherit;\n            font-weight: inherit;\n            &:visited,\n            &:active,\n            &:hover {\n                text-decoration: none;\n                color: inherit;\n            }\n        "], ["\n            color: inherit;\n            font-weight: inherit;\n            &:visited,\n            &:active,\n            &:hover {\n                text-decoration: none;\n                color: inherit;\n            }\n        "])));
});
var IconWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-left: 4px;\n"], ["\n    margin-left: 4px;\n"])));
var Link = function (_a) {
    var icon = _a.icon, iconProps = _a.iconProps, props = __rest(_a, ["icon", "iconProps"]);
    var theme = utils_1.useTheme();
    return (react_1.default.createElement(A, __assign({ href: props.href, target: props.target || '_blank', rel: "noreferrer noopener" }, props, { onClick: function (e) {
            // if the user passed custom onClick action, run it first
            if (props.onClick) {
                props.onClick(e);
            }
            // Prevent events from bubbling to the parent element.
            // E.g. we don't want the checkbox to be checked when user clicks on link in checkbox label
            e.stopPropagation();
        } }),
        props.children,
        icon && (react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(Icon_1.Icon, __assign({ size: props.size ? Number(A_SIZES[props.size].replace('px', '')) : 24, icon: icon, color: theme.TYPE_DARK_GREY }, iconProps))))));
};
exports.Link = Link;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
